<div class="helper-text-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Helper Text
      </label>
      <textarea
        #labelInput
        class="config-input label-input"
        [value]="question().labelText"
        (input)="onLabelChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter helper text"
        rows="4"></textarea>
    </div>
  } @else {
    <div class="question-preview">
      @if (question().labelText) {
        <div class="helper-text-content" [innerHTML]="sanitizeHtml(question().labelText)"></div>
      } @else {
        <div class="helper-text-placeholder">Helper Text</div>
      }
    </div>
  }
</div>

